<script setup>
import { defineProps } from 'vue'

defineProps({
  color: String
})
</script>
<template>
  <svg
    :style="`fill:rgb(var(--v-theme-${color}));`"
    class="grape"
    width="100%"
    height="100%"
    viewBox="0 0 1542 1248"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
  >
    <g transform="matrix(1,0,0,1,-8.16729,-146.375)">
      <path
        d="M1526.68,538.633C1556.57,651.677 1637.26,1150.46 1117.3,1309.02C597.34,1467.58 133.242,1415.08 25.92,1056.81C-81.401,698.54 317.46,267.509 695.089,174.111C1072.72,80.713 1444.66,228.409 1526.68,538.633Z"
      />
    </g>
  </svg>
</template>
